// components/AuthGuard.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from './Firebase';

const useLeagueData = (leagueId) => {
  const [leagueData, setLeagueData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeagueData = async () => {
      try {
        console.log('Fetching league data for leagueId:', leagueId);
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/competitions`);
        const competitions = await response.json();
        console.log('Competitions data:', competitions);

        let foundLeague = null;
        Object.keys(competitions).forEach(level => {
          const league = competitions[level].find(comp => comp.competition_id === parseInt(leagueId));
          if (league) foundLeague = league;
        });

        if (foundLeague) {
          setLeagueData(foundLeague);
          console.log('Found league:', foundLeague);
        } else {
          setError('Liga nie została znaleziona.');
          console.log('League not found for leagueId:', leagueId);
        }
      } catch (err) {
        setError('Błąd podczas pobierania danych ligi: ' + err.message);
        console.error('Error fetching league data:', err);
      } finally {
        setLoading(false);
        console.log('Finished fetching league data, loading:', false);
      }
    };

    if (leagueId) fetchLeagueData();
    else {
      console.log('No leagueId provided, skipping fetch');
      setLoading(false);
    }
  }, [leagueId]);

  return { leagueData, loading, error };
};

const AuthGuard = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && user.email === 'janowicz.kamil@gmail.com') {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div>Ładowanie...</div>;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export { AuthGuard, useLeagueData };